import { NO_EPG_ID } from '../index.h'

export {
  formatEpgRequestToFetchParams,
  markChannelsEpgAsPending,
  narrowEpgRequestToNecessary,
  unmarkChannelsEpgAsPending,
} from './epg'
export { inRange, rangeCovered, rangePosition } from './ranges'
export {
  formatEpgProgramRangeLabel,
  formatMidnightCrossingEpgRange,
  formatProgramEpgToFetchParams,
  getMapKeyForProgram,
  getProgramDayLabel,
  getProgramStartDay,
} from './upcoming'

// `epgId` getter
export const epgId = <T extends { epgId?: string }>(obj: T): string =>
  obj.epgId ?? NO_EPG_ID
